module.exports = __webpack_public_path__ + "img/3.5b83bdd3.png";